(() => {
  if (window.__BCKR_PDP_VIDEO_TRACKING__) return;
  window.__BCKR_PDP_VIDEO_TRACKING__ = true;

  const SCRIPT_VERSION = '2026-06-11-v3-watch-bucket';

  const config = window.BCKR_PDP_VIDEO_TRACKING || {};
  const trackedVideos = new WeakMap();
  const visibleTracked = new WeakSet();
  const progressMarks = [25, 50, 75];

  function pushVideoEvent(eventName, payload = {}) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      event_category: 'PDP Video',
      script_version: SCRIPT_VERSION,
      page_path: window.location.pathname,
      product_id: config.product_id || null,
      product_handle: config.product_handle || null,
      product_title: config.product_title || null,
      product_type: config.product_type || null,
      product_vendor: config.product_vendor || null,
      ...payload
    });
  }

  function getMediaId(el) {
    if (!el || !el.closest) return null;

    const wrapper = el.closest('[data-media-id]');
    const videoComponent = el.closest('video-component');

    return (
      videoComponent?.dataset?.videoId ||
      wrapper?.dataset?.mediaId ||
      null
    );
  }

  function getWatchBucket(percent) {
    if (percent === null || percent === undefined) return null;

    if (percent < 25) return 'under_25';
    if (percent < 50) return '25_49';
    if (percent < 75) return '50_74';
    if (percent < 100) return '75_plus';

    return 'complete';
  }

  function getVideoPayload(video, extra = {}) {
    const duration = Number.isFinite(video.duration)
      ? Math.round(video.duration)
      : null;

    const currentTime = Number.isFinite(video.currentTime)
      ? Math.round(video.currentTime)
      : 0;

    const percent = duration
      ? Math.min(100, Math.round((currentTime / duration) * 100))
      : null;

    const watchBucket = getWatchBucket(percent);

    return {
      video_media_id: getMediaId(video),
      video_src: video.currentSrc || video.src || null,
      video_duration: duration,
      video_current_time: currentTime,
      video_percent: percent,
      video_watch_bucket: watchBucket,
      ...extra
    };
  }

  function trackVisibleVideos() {
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('.product-media--video').forEach((container) => {
      if (visibleTracked.has(container)) return;
      visibleTracked.add(container);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

          pushVideoEvent('pdp_video_visible', {
            video_media_id: getMediaId(container)
          });

          observer.unobserve(container);
        });
      }, {
        threshold: [0.5]
      });

      observer.observe(container);
    });
  }

  function trackVideo(video) {
    if (trackedVideos.has(video)) return;

    const state = {
      started: false,
      completed: false,
      progressSent: new Set()
    };

    trackedVideos.set(video, state);

    video.addEventListener('play', () => {
      if (state.started) return;

      state.started = true;
      pushVideoEvent('pdp_video_start', getVideoPayload(video));
    });

    video.addEventListener('timeupdate', () => {
      if (!state.started) return;
      if (!Number.isFinite(video.duration) || video.duration <= 0) return;

      const percent = Math.round((video.currentTime / video.duration) * 100);

      progressMarks.forEach((mark) => {
        if (percent >= mark && !state.progressSent.has(mark)) {
          state.progressSent.add(mark);

          pushVideoEvent('pdp_video_progress', getVideoPayload(video, {
            video_progress_mark: mark
          }));
        }
      });
    });

    video.addEventListener('pause', () => {
      if (!state.started || state.completed || video.ended) return;

      const currentTime = Number.isFinite(video.currentTime)
        ? video.currentTime
        : 0;

      if (currentTime < 2) return;

      pushVideoEvent('pdp_video_pause', getVideoPayload(video));
    });

    video.addEventListener('ended', () => {
      if (state.completed) return;

      state.completed = true;

      pushVideoEvent('pdp_video_complete', getVideoPayload(video, {
        video_progress_mark: 100,
        video_watch_bucket: 'complete'
      }));
    });
  }

  function trackVideoButtonClicks() {
    document.querySelectorAll('.product-media__video-play-btn').forEach((button) => {
      if (button.dataset.bckrVideoClickTracked === 'true') return;
      button.dataset.bckrVideoClickTracked = 'true';

      button.addEventListener('click', () => {
        pushVideoEvent('pdp_video_play_click', {
          video_media_id: getMediaId(button)
        });
      });
    });
  }

  function init() {
    trackVisibleVideos();
    trackVideoButtonClicks();

    document.querySelectorAll('media-gallery video, .product-media--video video').forEach((video) => {
      trackVideo(video);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  init();

  const observer = new MutationObserver(init);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();